<template>
  <el-row class="demo-avatar demo-basic" type="flex" justify="center">
    <el-col :span="23">
      <div class="profile_zone mt-10" v-if="checkPermissionsPage('erlian_branch')">
        <span class="avatar_email mt-20 ml-3">Баянаа ахаа явуулах гэж байгаа газраа сонгоорой</span>
        <el-card class="w-100 mt-5">
          <el-select v-model="value" placeholder="Та харилцагч байгуулага сонгоно уу" class="w-100"
            @change="changeCompanyValue()">
            <el-option v-for="item in companies" :key="item.id" :label="item.company_name" :value="item.id">
              <span style="float: left">{{ item.company_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.nick_name }}</span>
            </el-option>
          </el-select>
        </el-card>
      </div>
      <div>
      </div>
      <!-- <div class="mt-10">
          <el-button class="w-100" type="primary" @click="logout()">Гарах</el-button>
        </div> -->
    </el-col>
  </el-row>
</template>
<script>
import {
  mapActions,
  mapGetters
} from 'vuex'
import { checkPermissions } from '@/helpers/custom'

export default {
  name: 'ProfilePage',
  computed: {
    ...mapGetters([
      'selectCompany'
    ])
  },
  data () {
    return {
      activeNames: '',
      companies: [{
        id: 1,
        company_name: 'Sky Cargo',
        nick_name: 'Анхаа'
      }, {
        id: 8,
        company_name: 'Мөөгий / 7588',
        nick_name: '7588'
      }],
      value: '',
      activeConfig: {}
    }
  },
  created () {
    this.value = this.selectCompany
  },
  methods: {
    ...mapActions(['setConfig']), // Vuex actions ашиглах

    handleChange () {

    },
    ...mapActions(['setCompany']), // Vuex actions ашиглах
    changeCompanyValue () {
      this.setCompany(this.value)
      this.$notify({
        title: 'Амжилттай',
        message: 'Харилцагч байгууллага солигдлоо',
        type: 'success'
      })
    },
    logout () {
      localStorage.clear()
      this.$router.push({
        path: '/login'
      })
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    }
  }
}

</script>
<style>
  .demo-avatar {
    justify-items: center;
  }

  .avatar_first_name {
    font-family: 'Geologica', sans-serif;
    font-weight: 400;
    font-size: 20px;
  }

  .avatar_email {
    font-weight: 200;
  }

  .profile_head_zone {
    text-align: center;
  }

  .profile_zone {}

</style>
